import { render, staticRenderFns } from "./PesquisaItensView.vue?vue&type=template&id=ba0eb29c&scoped=true"
import script from "./PesquisaItensView.vue?vue&type=script&lang=js"
export * from "./PesquisaItensView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0eb29c",
  null
  
)

export default component.exports